import React from "react";

import Legenda from "./Leyenda";
import AcademicCondition from "../AcademicCondition";

import "../secundariacss.css";

import Attendance from "../Attendance";
import Signatures from "../Signatures";
import Header from "../Header";
const SecundariaBulletin = ({ data }) => {
  return (
    <>
      <hr className="d-print-none"></hr>

      <div className="table-responsive">
        <Header data={data} />

        {data?.student_status_id === "1" || data?.role_id < 3 ? (
          <>
            <table
              className="beta bulletin"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td
                    className="text-center font-weight-bold"
                    colSpan={2 * data.p_1.length + 1}
                  >
                    Año Escolar 2020 - 2021
                  </td>
                </tr>
                <tr>
                  <td className="p-2" />
                  {data?.p_1 &&
                    data.p_1.map((item, index) => {
                      return (
                        <td
                          key={index + "subject_juntas_p1"}
                          colSpan={2}
                          className="text-center font-weight-bold"
                        >
                          {item.subject_name}
                        </td>
                      );
                    })}
                </tr>
                <tr>
                  <td className="p-2" />
                  {data?.p_1 &&
                    data.p_1.map((item, index) => {
                      return (
                        <React.Fragment key={"acad_conduct_n1" + index}>
                          <td className="text-center">Acad.</td>
                          <td className="text-center">Cond.</td>
                        </React.Fragment>
                      );
                    })}
                </tr>
                <tr>
                  <td className="text-center">1</td>
                  {data?.p_1 &&
                    data.p_1.map((item, index) => {
                      return (
                        <React.Fragment key={"grade_conduct_p1" + index}>
                          <td className="text-center">
                            {item.final_grade <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.final_grade}
                              </u>
                            ) : (
                              item.final_grade
                            )}
                          </td>
                          <td className="text-center">
                            {item.conduct <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.conduct}
                              </u>
                            ) : (
                              item.conduct
                            )}
                          </td>
                        </React.Fragment>
                      );
                    })}
                </tr>
                {/* 2nd period */}
                <tr>
                  <td className="text-center">2</td>
                  {data?.p_2
                    ? data.p_2.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p2" + index}>
                            <td className="text-center">
                              {item.final_grade <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.final_grade}
                                </u>
                              ) : (
                                item.final_grade
                              )}
                            </td>
                            <td className="text-center">
                              {item.conduct <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.conduct}
                                </u>
                              ) : (
                                item.conduct
                              )}
                            </td>
                          </React.Fragment>
                        );
                      })
                    : data.p_1.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p2" + index}>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })}
                </tr>
                <tr>
                  <td
                    className="pt-4 pl-2 font-weight-bold"
                    colSpan={2 * data?.p_1?.length + 1}
                  >
                    Promedio 1er Semestre
                  </td>
                </tr>
                <tr>
                  <td className="pl-2">PROMS.</td>
                  {data?.p_1 &&
                    data.PRO1.map((item, index) => {
                      return (
                        <React.Fragment key={"grade_conduct_proms" + index}>
                          <td className="text-center">
                            {item.final_grade <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.final_grade}
                              </u>
                            ) : (
                              item.final_grade
                            )}
                          </td>
                          <td className="text-center">
                            {item.conduct <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.conduct}
                              </u>
                            ) : (
                              item.conduct
                            )}
                          </td>
                        </React.Fragment>
                      );
                    })}
                </tr>
                <tr>
                  <td
                    className="pt-4 pl-2"
                    colSpan={2 * data?.p_1?.length + 1}
                  />
                </tr>
                <tr>
                  <td className="p-2" />

                  {data?.p_1 &&
                    data.p_1.map((item, index) => {
                      return (
                        <td
                          key={index + "subject-p2"}
                          colSpan={2}
                          className="text-center font-weight-bold"
                        >
                          {item.subject_name}
                        </td>
                      );
                    })}
                </tr>
                <tr>
                  <td className="juntas" />
                  {data?.p_1 &&
                    data.p_1.map((item, index) => {
                      return (
                        <React.Fragment key={"acad_conduct_n2" + index}>
                          <td className="text-center">Acad.</td>
                          <td className="text-center">Cond.</td>
                        </React.Fragment>
                      );
                    })}
                </tr>
                <tr>
                  <td className="text-center">3</td>
                  {data?.p_3
                    ? data.p_3.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p3" + index}>
                            <td className="text-center">
                              {item.final_grade <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.final_grade}
                                </u>
                              ) : (
                                item.final_grade
                              )}
                            </td>
                            <td className="text-center">
                              {item.conduct <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.conduct}
                                </u>
                              ) : (
                                item.conduct
                              )}
                            </td>
                          </React.Fragment>
                        );
                      })
                    : data.p_1.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p3" + index}>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })}
                </tr>
                <tr>
                  <td className="text-center">4</td>
                  {data?.p_4
                    ? data.p_4.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p4" + index}>
                            <td className="text-center">
                              {item.final_grade <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.final_grade}
                                </u>
                              ) : (
                                item.final_grade
                              )}
                            </td>
                            <td className="text-center">
                              {item.conduct <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.conduct}
                                </u>
                              ) : (
                                item.conduct
                              )}
                            </td>
                          </React.Fragment>
                        );
                      })
                    : data.p_1.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p4" + index}>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })}
                </tr>
                <tr>
                  <td
                    className="pt-4 pl-2 font-weight-bold"
                    colSpan={2 * data?.p_1?.length + 1}
                  >
                    Promedio 2do Semestre
                  </td>
                </tr>
                <tr>
                  <td className="pl-2">PROMS</td>
                  {data?.p_3 || data?.p_4 ? (
                    data.PRO2.map((item, index) => {
                      return (
                        <React.Fragment key={"proms_2" + index}>
                          <td className="text-center">
                            {item.final_grade <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.final_grade}
                              </u>
                            ) : (
                              item.final_grade
                            )}
                          </td>
                          <td className="text-center">
                            {item.conduct <= 70 ? (
                              <u className="font-weight-bold ">
                                {item.conduct}
                              </u>
                            ) : (
                              item.conduct
                            )}
                          </td>
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <>
                      {data?.p_1 &&
                        data.p_1.map((item, index) => {
                          return (
                            <React.Fragment key={"proms_2" + index}>
                              <td className="text-center"></td>
                              <td className="text-center"></td>
                            </React.Fragment>
                          );
                        })}
                    </>
                  )}
                </tr>
                <tr>
                  <td
                    className="pt-4 pl-2 font-weight-bold"
                    colSpan={2 * data?.p_1?.length + 1}
                  >
                    PROMEDIO FINAL:
                  </td>
                </tr>
                <tr>
                  <td className="pl-2">COMPLE.</td>
                  {data?.p_4
                    ? data.PROFIN.map((item, index) => {
                        return (
                          <React.Fragment key={"PROFIN_comple" + index}>
                            <td className="text-center">
                              {item.final_grade <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.final_grade_completive}
                                </u>
                              ) : (
                                item.final_grade_completive
                              )}
                            </td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })
                    : data.p_1.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p4" + index}>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })}
                </tr>
                <tr>
                  <td className="pl-2">PROM. FIN.</td>
                  {data?.p_4
                    ? data.PROFIN.map((item, index) => {
                        return (
                          <React.Fragment key={"PROFIN" + index}>
                            <td className="text-center">
                              {item.final_grade <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.final_grade}
                                </u>
                              ) : (
                                item.final_grade
                              )}
                            </td>
                            <td className="text-center">
                              {item.conduct <= 70 ? (
                                <u className="font-weight-bold ">
                                  {item.conduct}
                                </u>
                              ) : (
                                item.conduct
                              )}
                            </td>
                          </React.Fragment>
                        );
                      })
                    : data.p_1.map((item, index) => {
                        return (
                          <React.Fragment key={"grade_conduct_p4" + index}>
                            <td className="text-center"></td>
                            <td className="text-center"></td>
                          </React.Fragment>
                        );
                      })}
                </tr>
              </tbody>
            </table>

            <AcademicCondition condition={data?.condition} />
            <Attendance attendance={data?.general.attendance} />
            <Legenda />
            <Signatures
              coordinator={data?.general.coordinator}
              teacher={data?.general.teacher}
              director={data?.general.director}
            />
          </>
        ) : (
          <div>
            <div className="text-center">
              <span style={{ fontSize: "3em", color: "Tomato" }}>
                <i className="fas fa-exclamation-triangle fa-3x" />
              </span>
            </div>

            <h2 className="text-center font-weight-bold">
              Por favor comunícate con la Administración
            </h2>
          </div>
        )}
      </div>
      {/* <div className="page-break"></div> */}
    </>
  );
};
export default SecundariaBulletin;
